<template lang="pug">
	div.rounded-full.relative.overflow-hidden.flex.justify-center.bg-cover.bg-center.items-center.cursor-pointer(:style="{background: `${getBackground} center/cover`}" :class="size")
		div
			p.text-white.z-10.tracking-wider.relative(v-if="!profile.photoURL") {{initials}}
			.shader.rounded-full.absolute.bottom-0.-mb-4(v-if="!profile.photoURL" :class="size" :style="{background: shading}")
</template>

<script>
import { mapGetters } from "vuex";
import { ref, computed } from "@vue/composition-api";
import hexToHsl from "hex-to-hsl";
export default {
  props: ["size", "profile"],
  setup(props, { root }) {
    const shading = ref("");

    const getBackground = computed(() => {
      if (props.profile.photoURL) return `url('${props.profile.photoURL}')`;
      else {
        const hsl = hexToHsl(props.profile.colour);
        const h = calcHue(hsl[0]),
          s = hsl[1],
          l = hsl[2] - 5;

        shading.value = `hsl(${h},${s}%,${l}%)`;
        return props.profile.colour;
      }
    });
    const initials = computed(() => {
      if (props.profile.displayName) {
        const names = props.profile.displayName.split(" ");
        const initials = [];
        names.forEach(name => {
          initials.push(name[0]);
        });

        return initials.join("");
      } else {
        return props.profile.email[0].toUpperCase();
      }
    });

    function calcHue(hue) {
      if (hue <= 60) return hue - 20;
      else if (hue > 60 && hue <= 120) return hue + 20;
      else if (hue > 120 && hue <= 180) return hue - 20;
      else if (hue > 180 && hue <= 240) return hue + 20;
      else return hue - 20;
    }

    return { shading, calcHue, initials, getBackground };
  }
};
</script>

<style lang="sass" scoped>
.large
	@apply w-20 h-20 text-3xl

.medium
	@apply w-12 h-12

.small
	@apply w-8 h-8 text-xs

.tiny
	@apply w-6 h-6 text-xs

.shader
	filter: blur(16px)
</style>
